import SearchWatchListEntriesForm from './SearchWatchListEntriesForm';

export default SearchWatchListEntriesForm;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/search-watch-list-entries-form/index.js